export enum LoginTypeEnum {
    PASSWORD = "password",
    REFRESH_TOKEN = "refresh_token"
}
